const memory = new Map();

const canUseLocalStorage = () => {
  try {
    const key = '__auth_storage_test__';
    window.localStorage.setItem(key, '1');
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};

const persistent = typeof window !== 'undefined' && canUseLocalStorage();

const readPersisted = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

// Writes are always mirrored in memory so a read can fall back to them when
// localStorage is blocked, throws, or silently returns null (Safari-like).
const authStorage = {
  get(key) {
    const persisted = readPersisted(key);
    if (persisted !== null && persisted !== undefined) {
      return persisted;
    }
    return memory.has(key) ? memory.get(key) : null;
  },

  set(key, value) {
    memory.set(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // memory copy covers blocked storage
    }
  },

  remove(key) {
    memory.delete(key);
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // ignore
    }
  },

  clear() {
    memory.clear();
    try {
      window.localStorage.clear();
    } catch (error) {
      // ignore
    }
  },

  getJSON(key, fallback = null) {
    const raw = this.get(key);
    if (raw === null || raw === undefined) {
      return fallback;
    }
    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  },

  setJSON(key, value) {
    this.set(key, JSON.stringify(value));
  },

  isPersistent() {
    return persistent;
  },
};

export default authStorage;
